




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric, min, max } from 'vee-validate/dist/rules';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle, faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Swal from 'sweetalert2';

library.add(faInfoCircle);
library.add(faCalendarDay);
extend('required', required);
extend('numeric', numeric);
extend('min', min);
extend('max', max);

export interface Tracking {
  barcode: string;
  delivery_datetime: string;
  delivery_description: string;
  delivery_status: string;
  location: string;
  postcode: string;
  receiver_name: string;
  signature: string;
  status: string;
  status_date: string;
  status_description: string;
}

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FontAwesomeIcon,
  },
})
export default class TrackingReceiptView extends Vue {
    private STATUS_CODE_COMPLETE = '501';
    private trackingList = [] as Tracking[];
    private selectAll = false;
    private isSearchSubmit = false;
    private selectedTrackingList = [];
    private form = {
      receiptNo: null,
    };

    private created() {
      this.$http.get('/api/auth');
    }

    private async searchReceipt() {
      // tslint:disable: no-console
      Swal.fire({
        title: 'กำลังค้นหาข้อมูล',
        allowOutsideClick: false,
        onBeforeOpen: async () => {
          try {
            Swal.showLoading();
            const { receiptNo } = this.form;
            const res = await this.$http.get(`/api/tracking-receipts?receiptNo=${receiptNo}`);
            this.isSearchSubmit = true;
            const trackings = res.data;
            this.trackingList = trackings;
          } catch (err) {
            console.log(err);
          } finally {
            Swal.close();
          }
        },
      });
    }

    private confirmTrackingReceipt() {
      Swal.fire({
        title: 'ยืนยัน',
        text: `จำนวน ${this.selectedTrackingList.length} รายการ`,
        allowOutsideClick: false,
        confirmButtonText: 'ยืนยัน',
        confirmButtonColor: '#ec1b23',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.value) {
          this.submitTrackingReceipt();
        }
      });
    }

    private submitTrackingReceipt() {
      Swal.fire({
        title: 'กำลังส่งข้อมูล',
        allowOutsideClick: false,
        onBeforeOpen: async () => {
          Swal.showLoading();
          try {
            const params = this.selectedTrackingList;
            const res = await this.$http.post(`/api/tracking-receipts`, params);
            Swal.close();
            Swal.fire({
              title: 'ติดตามสถานะ',
              html: `<p class="text-center"><img src="/images/submit-check.png" style="width: 25%;" /></p>
                <div>ติดตามสถานะสิ่งของเรียบร้อยแล้ว</div>`,
              showConfirmButton: true,
            }).then((result) => {
              this.resetData();
            });
          } catch (err) {
            console.log(err);
            let text = 'กรุณาลองใหม่อีกครั้ง';
            if (err.body) {
              const { code, message } = err.body;
              if (code === 'not_found') {
                const trackingNumber = message;
                text = `ไม่พบข้อมูล ${trackingNumber}`;
              }
              if (code === 'invalid_data') {
                text = `ข้อมูลไม่ถูกต้อง`;
              }
            }
            Swal.close();
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text,
              focusConfirm: false,
              focusCancel: false,
              confirmButtonText: 'ตกลง',
              confirmButtonColor: '#ec1b23',
            });
          }
        },
      });
    }

    private viewDesc() {
      Swal.fire({
        imageUrl: '/images/exp-bill.jpg',
        imageAlt: 'ตัวอย่างกรอกรหัสไปรษณีย์ตามด้วยเลข TR',
        confirmButtonText: 'ตกลง',
      });
    }

    private resetData() {
      this.trackingList = [];
      this.selectedTrackingList = [];
      this.form.receiptNo = null;
      this.isSearchSubmit = false;
      this.selectAll = false;
      (this.$refs.observer as Vue & { reset: () => boolean }).reset();
    }

    private getDateFormat(dateStr: string) {
      return dateStr.split('+')[0];
    }

    get hasTrackingList() {
      return this.trackingList.length > 0;
    }

    get getSelectAllText() {
      return this.selectAll ? 'ยกเลิก' : 'เลือกทั้งหมด';
    }

    private isTrackingAllComplete() {
      const trackingCompleteList = this.trackingList.filter((tracking) => tracking.status === '501');
      console.log(trackingCompleteList, this.trackingList);
      return trackingCompleteList.length === this.trackingList.length;
    }

    @Watch('selectAll')
    private selectAllChange(value: string, oldValue: string) {
      if (value) {
        this.selectedTrackingList = [];
        for (const tracking of this.trackingList) {
          if (tracking.status !== this.STATUS_CODE_COMPLETE) {
            this.selectedTrackingList.push(tracking.barcode);
          }
        }
      } else {
        this.selectedTrackingList = [];
      }
    }
}
